// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EB3IrN{font:"font(--itemDetailsFont)"}.EB3IrN.dKuRF8{padding-bottom:36px}.EB3IrN.bhUN74{position:relative;padding:25px 0}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardDetailsWrapper": `EB3IrN`,
	"desktop": `dKuRF8`,
	"mobile": `bhUN74`
};
export default ___CSS_LOADER_EXPORT___;
